// extracted by mini-css-extract-plugin
export default {"label":"Radio_label__WpAYC","disabled":"Radio_disabled__Pcqjh","medium-radio":"Radio_medium-radio__JcKiB","large-radio":"Radio_large-radio__JM942"};